import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_marketing/terms")({
  component: TermsPage,
});

function TermsPage() {
  return (
    <section className="py-section-sm md:py-section">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <div className="bg-arc-base-white rounded-2xl p-6 sm:p-8 md:p-12 lg:p-16">
          <div className="mx-auto max-w-3xl">
            <h1 className="text-display-sm md:text-display-md text-arc-base-black mb-4 font-semibold md:mb-6">
              Terms & Conditions
            </h1>
            <p className="text-arc-gray-700 mb-6 text-base md:mb-8 md:text-lg">
              This is a placeholder Terms & Conditions page for ARC Scotland’s E‑Learning platform.
              The full policy will be published here soon.
            </p>

            <div className="text-arc-gray-700 space-y-6 text-base md:space-y-8 md:text-lg">
              <section>
                <h2 className="mb-2 text-xl font-semibold md:text-2xl">Use of the Site</h2>
                <p>
                  By accessing this site, you agree to abide by the terms and any applicable
                  policies we publish here.
                </p>
              </section>

              <section>
                <h2 className="mb-2 text-xl font-semibold md:text-2xl">Limitation of Liability</h2>
                <p>
                  Content is provided for information only. We will publish the full terms
                  describing responsibilities and limitations.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
